'use client'

import * as React from 'react'
import { cn } from '../../utils/cn'
import { cva } from 'class-variance-authority'

const badgeVariants = cva(
  [
    'inline-flex items-center justify-center',
    'font-medium rounded-full',
    'transition-colors duration-150',
  ],
  {
    variants: {
      variant: {
        default: [
          'bg-[var(--landing-bg-card)]',
          'border border-[var(--landing-border)]',
          'text-[var(--landing-text-secondary)]',
        ],
        outline: [
          'bg-transparent',
          'border border-[var(--landing-border)]',
          'text-[var(--landing-text-secondary)]',
        ],
        accent: [
          'bg-[var(--landing-bg)]',
          'border border-[var(--accent)]',
          'text-[var(--accent)]',
        ],
      },
      size: {
        sm: 'px-2 py-0.5 text-xs',
        md: 'px-3 py-1 text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
)

export interface BadgeProps {
  children: React.ReactNode
  variant?: 'default' | 'outline' | 'accent'
  size?: 'sm' | 'md'
  className?: string
}

export function Badge({
  children,
  variant = 'default',
  size = 'md',
  className
}: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant, size }), className)}>
      {children}
    </span>
  )
}
